'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const BreadcrumbPage = forwardRef(({ className, ...props }, ref) => (_jsx("span", { ref: ref, role: "link", "aria-disabled": "true", "aria-current": "page", className: cn('flex items-center gap-2 font-normal text-metal-900 dark:text-white', className), ...props })));
BreadcrumbPage.displayName = 'BreadcrumbPage';
export { BreadcrumbPage };
